export default __webpack_public_path__ + "static/media/SelfServiceKiosk2.43ef61b1.jpeg";